import { CompanyStoreModel, BalanceZoneStoreModel, UserStoreModel } from './store.model';
import { ZonaBalanceElemLogModelResponse } from '../api/oData/model/ZonaBalanceElemLogModelResponse';
import { User } from '../model/RBAC';
import { EmpresaResponse } from '../api/Pioneer/model/Subject';

export const userMapperToStore = (item: User): UserStoreModel => item && item;

export const mapCompaniesToStore = (items: EmpresaResponse[]): CompanyStoreModel[] => {
  return items && items.map(mapCompanyToStore);
};

const mapCompanyToStore = (item: EmpresaResponse): CompanyStoreModel => {
  return (
    item && {
      id: item.idEmpresa,
      description: item.sujetos && item.sujetos.length === 1 ? item.sujetos[0].deSujeto! : '',
      default: item.esPrincipal,
      abbreviation:
        item.sujetos && item.sujetos.length === 1
          ? item.sujetos[0].deSujeto!.slice(0, 3).toUpperCase()
          : '',
      commodities: item.commodities
    }
  );
};

export const mapBalanceZonesToStore = (
  items: ZonaBalanceElemLogModelResponse[]
): BalanceZoneStoreModel[] => {
  return items && items.map(mapBalanceZoneToStore);
};

const mapBalanceZoneToStore = (item: ZonaBalanceElemLogModelResponse): BalanceZoneStoreModel => {
  return (
    item && {
      id: item.id,
      description: item.descripcion !== undefined ? item.descripcion : '',
      code: item.codigo !== undefined ? item.codigo : ''
    }
  );
};
